/* @flow */
import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';

import type { TranslatorProps } from 'react-i18next';

import type TypeActionDrawerStore from 'stores/ActionDrawerStore';

import Form from 'forms/_.extend';
import Loading from 'components/Loading/Loading';
import ActionDrawerHeader from 'views/ActionDrawer/components/ActionDrawerHeader/ActionDrawerHeader';

import ArchiveLocationByCompanyForm from './ArchiveLocationByCompanyForm/ArchiveLocationByCompanyForm';
import ArchiveLocationByCompanySuccess from './ArchiveLocationByCompanySuccess/ArchiveLocationByCompanySuccess';
import ArchiveLocationByCompanyError from './ArchiveLocationByCompanyError/ArchiveLocationByCompanyError';

import styles from '../../../ActionDrawer.module.scss';

type TypeProps = {|
  actionDrawerStore: TypeActionDrawerStore,
  location: Object,
  locationStore: Object,
|} & TranslatorProps;

@translate()
@inject('actionDrawerStore', 'locationStore')
@observer
export default class ArchiveLocationByCompany extends React.Component<*> {
  createForm = () => {
    const { t, actionDrawerStore, locationStore, location }: TypeProps = this.props;

    const fields: Array<Object> = [
      {
        name: 'selectLocation',
        fields: [
          {
            name: 'locations',
            label: t('general:roles.user_plural'),
            rules: 'required|array|min:1',
            value: [],
          },
        ],
      },
    ];

    const hooks: Object = {
      onInit() {
        const companyId = location.details.id;

        if (locationStore.locations.active.length === 0) {
          locationStore.loadLocationsByCompany(companyId);
        }
      },
      onSuccess(data: Object) {
        const companyId = location.details.id;
        const locations = data.values().selectLocation;

        actionDrawerStore.archiveLocationsByCompany(companyId, locations);
      },
    };

    return new Form(
      { fields },
      {
        hooks,
        name: 'archiveLocationByCompany',
      }
    );
  };

  render(): React.Element<*> {
    const { t, actionDrawerStore, location }: TypeProps = this.props;

    const title: string = t('general:actions.archive_location_plural');

    if (actionDrawerStore.loading) {
      return <Loading />;
    }

    if (actionDrawerStore.error) {
      return (
        <div className={`${styles['action-drawer-form']} ${styles.error}`}>
          <ActionDrawerHeader title={title} />
          <ArchiveLocationByCompanyError location={location} />
        </div>
      );
    }

    if (actionDrawerStore.success) {
      return (
        <div className={`${styles['action-drawer-form']} ${styles.success}`}>
          <ActionDrawerHeader title={title} />
          <ArchiveLocationByCompanySuccess response={actionDrawerStore.response} />
        </div>
      );
    }

    return (
      <div className={styles['action-drawer-form']}>
        <ActionDrawerHeader title={title} />
        <ArchiveLocationByCompanyForm companyId={location.details.id} form={this.createForm()} />
      </div>
    );
  }
}
